import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import {
  SdIconComponent,
  SdLinkComponent,
  SdPriceComponent,
  ThemesEnum
} from '@seb/web-design-system/core';
import { IProductLinkCard } from './product-link-card.interface';

@Component({
  selector: 'sd-product-link-card',
  templateUrl: './product-link-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./product-link-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdIconComponent,
    SdPriceComponent,
    SdLinkComponent
  ]
})
export class SdProductLinkCardComponent {
  @Input()
  data: IProductLinkCard;

  @Input()
  hidePrice: boolean;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.data?.theme === ThemesEnum.light ? 'is-theme-light' : 'is-theme-default'
    ].filter(Boolean).join(' ');
  }
}
